<script setup lang="ts">
const { t } = useI18n();
const { visible, dismiss } = useSessionExpiredNotice();
</script>

<template>
  <WebBanner
    v-if="visible"
    data-testid="session-expired-banner"
    :title="t('toast.auth.sessionExpired.title')"
    :description="t('toast.auth.sessionExpired.description')"
    closable
    @close="dismiss"
  />
</template>
